/**
 * Created by mauget on 4/9/16.
 */

//============================================================
// PF-532.
// Color picker configuration for Spectrum. Define
// the color picker appearance and behavior for the entire
// application. See https://bgrins.github.io/spectrum/#options-color
// for config options
//
// import { pickerCfg } 'pickerCfg.js';
//
// Append .spectrum( pickterConfig ) to any JQuery expression
// that refers to an <input type="color" ..
//============================================================
export const pickerCfg = {
    showInput: true,
    showInitial: true,
    showSelectionPalette: true,
    preferredFormat: 'hex',
    clickoutFiresChange: false
};

